module.exports = __webpack_public_path__ + "img/logo.7256d719.png";